import axiosClient from './axiosClient';

export const getQuoteDetailVersion = (paramId?:any): Promise<any> => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/quotes-document/version/${paramId}`;
    return axiosClient.get(url);
};
